function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "88",
  viewBox: "0 0 24 24",
  style: {
    height: "88px",
    width: "88px"
  },
  fill: "#2970ff"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 12a1.39 1.39 0 11-1.38-1.38A1.37 1.37 0 0116 12zm-6.62-1.38A1.38 1.38 0 1010.77 12a1.38 1.38 0 00-1.39-1.38zm5.56-3.87H8.12a4.6 4.6 0 00-4.62 4.57v5.93h11.7a5.27 5.27 0 003.88-1.67 5.18 5.18 0 001.41-3.91 5.43 5.43 0 00-5.55-4.92m0-1.5a7 7 0 017 6.33 6.78 6.78 0 01-6.79 7.17H2v-7.43a6.1 6.1 0 016.12-6.07h6.82z"
}));